import * as React from 'react';
import type { EditorPreset } from '.';
import { CommentsMenuBar } from './comments';
import { GuideIntroMenuBar } from './guide_intro';
import { AnswersMenuBar } from './answers';
import { WikiMenuBar } from './wiki';
import { useEditorContext } from '../editor_context';

export const MenuBar = (props: { preset: EditorPreset }) => {
   const { preset } = props;
   const { editor } = useEditorContext();

   if (!editor) {
      return null;
   }

   switch (preset) {
      case 'comments':
         return <CommentsMenuBar />;
      case 'guide_intro':
         return <GuideIntroMenuBar />;
      case 'answers':
         return <AnswersMenuBar />;
      case 'wiki':
         return <WikiMenuBar />;
      default:
         throw new Error(`Invalid preset: ${preset}`);
   }
};
